import LoyaltyButton from './LoyaltyButton';
import './LoyaltyButton.css';

export default LoyaltyButton;



// WEBPACK FOOTER //
// ./src/pages/Account/components/LoyaltyButton/index.js